// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Url({ value }) {
  return (
    <div className="url--backend--container">
      <a className="url--backend" href={value} target="_blank" rel="noreferrer">{value}</a>
    </div>
  );
}

Url.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Url;
